jQuery(function($) {
    
    lucide.createIcons();
});
